export function listOrdersByTrNumber(trNumber: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/orders/all/by-tire-rack-order-number/${trNumber}`,
  }
}
